
<div class="week-day-service-text" :class="getOccupation">
  <div>{{ ms.substr(0, 3) }} {{ getOccupationByServiceAndDay(date, ms) }}/{{ this.getAllCouverts(date, ms) }}</div>
</div>
